"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider, darkTheme } from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { wagmiConfig } from "./config";
import "@rainbow-me/rainbowkit/styles.css";
const queryClient = new QueryClient();
export function WalletProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = darkTheme({
      accentColor: "#d4a853",
      accentColorForeground: "#1a1a1a",
      borderRadius: "medium"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <WagmiProvider config={wagmiConfig}><QueryClientProvider client={queryClient}><RainbowKitProvider theme={t1}>{children}</RainbowKitProvider></QueryClientProvider></WagmiProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}